import { render, staticRenderFns } from "./DevDesignIllustrations.vue?vue&type=template&id=b1da859c&scoped=true"
import script from "./DevDesignIllustrations.vue?vue&type=script&lang=js"
export * from "./DevDesignIllustrations.vue?vue&type=script&lang=js"
import style0 from "./DevDesignIllustrations.vue?vue&type=style&index=0&id=b1da859c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1da859c",
  null
  
)

export default component.exports